import React from "react";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer style={{ 
      backgroundColor: "#0c1f0e",
      color: "#f8fffb",
      padding: "80px 20px 40px",
      fontFamily: "'Poppins', sans-serif",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Decorative elements */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "4px",
        background: "linear-gradient(90deg, #57a649, #3eae26)"
      }}></div>
      
      <div style={{ 
        display: "grid", 
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
        gap: "50px", 
        maxWidth: "1200px", 
        margin: "0 auto",
        position: "relative",
        zIndex: 1
      }}>
        
        {/* Bank Information */}
        <div>
          <div style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "25px"
          }}>
            <div style={{
              width: "50px",
              height: "50px",
              backgroundColor: "#57a649",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "15px",
              boxShadow: "0 4px 12px rgba(87, 166, 73, 0.3)"
            }}>
              <span style={{ 
                color: "#fff",
                fontSize: "24px",
                fontWeight: "700"
              }}>FB</span>
            </div>
            <h2 style={{ 
              color: "#f8fffb",
              fontSize: "24px",
              fontWeight: "700",
              margin: 0
            }}>
              Farmers Bank
            </h2>
          </div>
          
          <p style={{ 
            marginBottom: "25px", 
            lineHeight: "1.7",
            fontSize: "15px",
            opacity: "0.9"
          }}>
            Committed to serving our community with integrity and innovation through modern banking solutions.
          </p>
          
          <div style={{ 
            display: "flex", 
            gap: "15px",
            marginTop: "30px"
          }}>
            {[
              { icon: <FaFacebook />, color: "#1877F2" },
              { icon: <FaTwitter />, color: "#1DA1F2" },
              { icon: <FaLinkedin />, color: "#0077B5" },
              { icon: <FaInstagram />, color: "#E1306C" }
            ].map((social, index) => (
              <a 
                key={index}
                href="#" 
                style={{ 
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: social.color,
                  fontSize: "18px",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                  ":hover": {
                    backgroundColor: "rgba(255,255,255,0.2)",
                    transform: "translateY(-3px)"
                  }
                }}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Contact Info */}
        <div>
          <h3 style={{ 
            color: "#57a649",
            marginBottom: "25px",
            fontSize: "18px",
            fontWeight: "600",
            position: "relative",
            paddingBottom: "15px",
            letterSpacing: "0.5px"
          }}>
            <span style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "50px",
              height: "3px",
              background: "linear-gradient(90deg, #57a649, #3eae26)",
              borderRadius: "3px"
            }}></span>
            Contact Information
          </h3>
          
          <div style={{ 
            display: "grid",
            gap: "20px"
          }}>
            {[
              { 
                icon: <FaMapMarkerAlt style={{ color: "#57a649", fontSize: "18px" }} />,
                title: "Manzini Branch",
                content: "Corner of Louw & Ngwane Street, Manzini, Eswatini"
              },
              { 
                icon: <FaPhone style={{ color: "#57a649", fontSize: "18px" }} />,
                content: "+268 2505 0888"
              },
              { 
                icon: <FaEnvelope style={{ color: "#57a649", fontSize: "18px" }} />,
                content: "info@farmersbank.co.sz"
              },
              { 
                icon: <FaClock style={{ color: "#57a649", fontSize: "18px" }} />,
                content: "Mon-Fri: 8:30AM - 4:30PM"
              }
            ].map((item, index) => (
              <div key={index} style={{ 
                display: "flex",
                gap: "15px",
                alignItems: "flex-start"
              }}>
                <div style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "8px",
                  backgroundColor: "rgba(87, 166, 73, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}>
                  {item.icon}
                </div>
                <div>
                  {item.title && <p style={{ 
                    margin: "0 0 5px 0", 
                    fontWeight: "600",
                    fontSize: "15px"
                  }}>{item.title}</p>}
                  <p style={{ 
                    margin: 0, 
                    opacity: "0.9",
                    fontSize: "14px",
                    lineHeight: "1.6"
                  }}>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Google Map - Modernized */}
        <div style={{ 
          gridColumn: "span 2",
          height: "100%"
        }}>
          <h3 style={{ 
            color: "#57a649",
            marginBottom: "25px",
            fontSize: "18px",
            fontWeight: "600",
            position: "relative",
            paddingBottom: "15px",
            letterSpacing: "0.5px"
          }}>
            <span style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "50px",
              height: "3px",
              background: "linear-gradient(90deg, #57a649, #3eae26)",
              borderRadius: "3px"
            }}></span>
            Visit Our Branch
          </h3>
          
          <div style={{ 
            width: "100%", 
            height: "300px",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            position: "relative",
            border: "1px solid rgba(255,255,255,0.1)"
          }}>
            <iframe
              title="Farmers Bank Manzini Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.0464565210675!2d31.3795130754393!3d-26.498727377059087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x16f9e7e9229d641f!2sFarmers%20Bank%20-%20Manzini%20Branch!5e0!3m2!1sen!2ssz!4v1692198123456!5m2!1sen!2ssz"
              width="100%"
              height="100%"
              style={{ border: "none", filter: "grayscale(20%) contrast(110%)" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
            
            <div style={{
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              padding: "15px",
              background: "linear-gradient(transparent, rgba(0,0,0,0.7))",
              color: "white",
              fontSize: "14px"
            }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <FaMapMarkerAlt style={{ color: "#57a649", marginRight: "10px" }} />
                <span>Manzini Branch Location</span>
              </div>
            </div>
          </div>
          
          <p style={{ 
            marginTop: "15px", 
            fontSize: "14px", 
            opacity: "0.8",
            textAlign: "center"
          }}>
            Parking available • Wheelchair accessible • ATM on site
          </p>
        </div>
      </div>

      {/* Bottom section - Modernized */}
      <div style={{ 
        maxWidth: "1200px",
        margin: "50px auto 0",
        paddingTop: "30px",
        borderTop: "1px solid rgba(255,255,255,0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
        <div style={{ 
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
          marginBottom: "20px"
        }}>
          {["Privacy Policy", "Terms of Service", "Security", "Careers", "Compliance", "Accessibility"].map((item, index) => (
            <a 
              key={index}
              href="#" 
              style={{ 
                color: "#f8fffb",
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "500",
                position: "relative",
                padding: "5px 0",
                ":hover": {
                  color: "#57a649"
                },
                "::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "0",
                  left: "0",
                  width: "0",
                  height: "2px",
                  backgroundColor: "#57a649",
                  transition: "width 0.3s ease"
                },
                ":hover::after": {
                  width: "100%"
                }
              }}
            >
              {item}
            </a>
          ))}
        </div>
        
        <div style={{ 
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginBottom: "20px"
        }}>
          <div style={{
            width: "100px",
            height: "1px",
            background: "rgba(255,255,255,0.2)"
          }}></div>
          <span style={{ opacity: "0.7" }}>© {new Date().getFullYear()}</span>
          <div style={{
            width: "100px",
            height: "1px",
            background: "rgba(255,255,255,0.2)"
          }}></div>
        </div>
        
        <p style={{ 
          margin: 0, 
          opacity: "0.7",
          fontSize: "13px",
          textAlign: "center",
          maxWidth: "600px"
        }}>
         
        </p>
      </div>
    </footer>
  );
};

export default Footer;